import { FC, useState } from "react";
import { CreateTravelBlockPassengerForm } from "Bands/containers";
import { EventTravelLegType } from "Bands/types";
import { Spacer } from "shared/layout";
import { Button, Message, Title } from "shared/components";
import { copy } from "shared/assets";
import { ITheme } from "shared/types";
import { Icon } from "shared/styles";
import { Plus } from "shared/assets/icons";
import { PassengerTable } from ".";

const passengerCopy = copy.travelBlock.passenger;

interface Props {
  blockId: string;
  travelLegs: EventTravelLegType[];
}

export const AddPassenger: FC<Props> = ({ blockId, travelLegs }) => {
  const [showForm, setShowForm] = useState(false);

  const getContent = () => {
    if (!travelLegs.length) {
      return <Message message={passengerCopy.messages.addTravelLeg} />;
    }

    return (
      <>
        <Button
          theme={ITheme.secondary}
          onClick={() => setShowForm(!showForm)}
          disabled={showForm}
          data-testid="add_passenger"
        >
          <Spacer spaceDirection="horizontal" size="xxs" align="center">
            <Icon as={Plus} />
            <span>{passengerCopy.buttons.add}</span>
          </Spacer>
        </Button>
        {showForm && (
          <CreateTravelBlockPassengerForm
            blockId={blockId}
            travelLegs={travelLegs}
            handleClose={() => setShowForm(false)}
          />
        )}
        <PassengerTable blockId={blockId} travelLegs={travelLegs} showActions />
      </>
    );
  };

  return (
    <Spacer size="m">
      <Title size="s" asComponent="h3">
        {passengerCopy.title}
      </Title>
      {getContent()}
    </Spacer>
  );
};
